import get from 'lodash/get'
import { TextField, useRecordContext } from 'react-admin'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()({
  preferredSalutation: { 'font-weight': 'bold' },
})

const CustomerTextField = ({ source, ...rest }) => {
  const record = useRecordContext(rest)
  const customerPath = source.match(/^(.*)\./)
  const customer = customerPath ? get(record, customerPath[1]) : record
  const { classes } = useStyles()
  const classNames = {
    firstname: customer?.informal_salutation ? classes.preferredSalutation : '',
    lastname: customer?.informal_salutation ? '' : classes.preferredSalutation,
  }
  return (
    // The source is a path from the record ('related.firstname'), so the
    // field reads the record; the customer only decides the bold name.
    <TextField
      record={record}
      source={source}
      className={classNames[source.split('.').pop()]}
      {...rest}
    />
  )
}

CustomerTextField.displayName = 'CustomerTextField'

export default CustomerTextField
